/* global I18n */

import React, {useState, useEffect} from "react"
import KenhubModal from "../kenhub_modal"
import AnsweredExercise from "./answered_exercise"
import FaIcon from "components/fa_icon"
import FilterBadge from "./filter_badge"
import ExamQuestionSummary from "./exam_question_summary"
import {Tooltip, TooltipContent, TooltipTrigger} from "../tooltip"
import {use_modal} from "../../modal_provider"

const filters = ["success", "failed", "skipped"]

function ExamSummaryModal({
  is_open,
  on_close,
  filter,
  exercises,
  revise_exam_quiz,
  can_train
}) {
  const {close_modal} = use_modal()
  const [all_filter, set_all_filter] = useState(!filter)
  const [active_filters, set_active_filters] =
    useState(filter ? [filter] : filters)

  const answered_correctly =
    exercises.filter(ex => ex.answer_status === "success")
  const answered_incorrectly =
    exercises.filter(ex => ex.answer_status === "failed")
  const not_answered = exercises.filter(ex => ex.answer_status === "skipped")

  const filtered_exercises =
    exercises.filter(ex => active_filters.includes(ex.answer_status))
  const configuration = {
    exercises: filtered_exercises.map((exercise) => exercise.id)
  }
  const [question_modal_is_open, set_question_modal_is_open] = useState(false)

  useEffect(() => {
    set_all_filter(!filter)
    set_active_filters(filter ? [filter] : filters)
  }, [filter])

  function toggle_filter(filter) {
    if (filter === "all") {
      set_all_filter(true)
      set_active_filters(filters)
    } else if (all_filter) {
      set_all_filter(false)
      set_active_filters([filter])
    } else {
      if (active_filters.includes(filter)) {
        if (active_filters.length === 1) {
          set_all_filter(true)
          set_active_filters(filters)
          return
        }
        set_active_filters(active_filters.filter(f => f !== filter))
      } else {
        set_active_filters(active_filters.concat(filter))
      }
    }
  }

  return (
    <KenhubModal
      identifier="exam_summary"
      class_name="modal-wide exam-summary"
      label={I18n.t("js.embedded_quiz.exam_summary.details.your_details")}
      on_close={() => {
        on_close()
        set_question_modal_is_open(false)
      }}
      is_open={is_open}>
      {!question_modal_is_open &&
        <div className="exam-quiz-summary">
          <div className="modal-header">
            <h3 className="modal-title">
              {I18n.t(
                "js.embedded_quiz.exam_summary.details.your_details"
              )}
              <button
                className="btn btn-link close"
                onClick={close_modal}
              >
              </button>
            </h3>
            <div className="filters">
              <div className="key">
                {I18n.t("js.embedded_quiz.exam_summary.details.filter")}:
              </div>
              <FilterBadge
                name="all"
                on_click={() => toggle_filter("all")}
                is_active={all_filter}
              >
                {I18n.t("js.embedded_quiz.exam_summary.details.all")}
              </FilterBadge>
              <FilterBadge
                name="success"
                on_click={() => toggle_filter("success")}
                is_active={!all_filter && active_filters.includes("success")}
              >
                <FaIcon name="fa-check"/>
                <span>{answered_correctly.length}</span>
                {I18n.t("js.embedded_quiz.exam_summary.correct")}
              </FilterBadge>
              <FilterBadge
                name="failed"
                on_click={() => toggle_filter("failed")}
                is_active={!all_filter && active_filters.includes("failed")}
              >
                <FaIcon name="fa-times"/>
                <span>{answered_incorrectly.length}</span>
                {I18n.t("js.embedded_quiz.exam_summary.incorrect")}
              </FilterBadge>
              <FilterBadge
                name="skipped"
                on_click={() => toggle_filter("skipped")}
                is_active={!all_filter && active_filters.includes("skipped")}
              >
                <FaIcon name="fa-minus"/>
                <span>{not_answered.length}</span>
                {I18n.t("js.embedded_quiz.exam_summary.skipped")}
              </FilterBadge>
            </div>
          </div>
          <div className="modal-body">
            <div className="questions">
              {filtered_exercises.map(exercise => (
                <AnsweredExercise
                  key={exercise.id}
                  exercise={exercise}
                  index={exercise.index}
                  on_click={() => set_question_modal_is_open(exercise)}
                />
              ))}
            </div>
          </div>
          <div className="footer">
            <Tooltip>
              <TooltipTrigger>
                <button
                  className="btn btn-primary"
                  onClick={(e) => {
                    e.stopPropagation()
                    return revise_exam_quiz("exam_mode", configuration)
                  }}
                  disabled={filtered_exercises.length === 0 || !can_train}
                >
                  {I18n.t("js.embedded_quiz.exam_summary.details.revise")}
                  <span>({filtered_exercises.length})</span>
                </button>
              </TooltipTrigger>
              {!can_train &&
                <TooltipContent>
                  <span className="bold">
                    {I18n.t(
                      "js.embedded_quiz.exam_summary.details.tooltip"
                    )}
                  </span>
                </TooltipContent>}
            </Tooltip>
          </div>
        </div>
      }
      {question_modal_is_open &&
        <ExamQuestionSummary
          exercise={question_modal_is_open}
          set_question_modal_is_open={set_question_modal_is_open}
        />
      }
    </KenhubModal>
  )
}

export default ExamSummaryModal
